<div class="grid grid-rows-[auto_1fr_auto] min-h-screen">
  <app-header></app-header>
  <main class="flex-1">
    <app-crafting></app-crafting>
  </main>
  <app-footer></app-footer>
</div>

